const state = {
  userId: null,
  fee: null,
  doctorId: null,
  typeDoctorId: null,
  firstName: null,
  lastName: null,
  imageUrl: null,
  imageUserUrl: null,
  email: null,
  role: null,
  tokenExpire: null,
  accessToken: null,
  tel: null,
  clinicId: null,
  clinicName: null,
  branchId: null,
  branchName: null
}

const actions = {
  setBranch ({ commit }, payload) {
    commit('SET_BRANCH', payload)
  },
  resetBranch  ({ commit }) {
    commit('RESET_BRANCH')
  },
  setUserImageUrl ({ commit }, payload) {
    commit('SET_IMAGEURL_USER', payload)
  }
}

const mutations = {
  SET_IMAGEURL_USER (state, payload) {
    state.imageUserUrl = payload
  },
  SET_BRANCH (state, payload) {
    state.userId = payload.userId
    state.fee = payload.fee
    state.doctorId = payload.doctorId
    state.typeDoctorId = payload.typeDoctorId
    state.firstName = payload.firstName
    state.lastName = payload.lastName
    state.imageUrl = payload.imageUrl
    state.imageUserUrl = payload.imageUserUrl
    state.email = payload.email
    state.role = payload.role
    state.tel = payload.tal
    state.clinicId = payload.clinicId
    state.clinicName = payload.clinicName
    state.branchId = payload.branchId
    state.branchName = payload.branchName
    state.tokenExpire = payload.tokenExpire
    state.accessToken = payload.accessToken
  },
  RESET_BRANCH (state) {
    state.userId = null
    state.fee = null
    state.doctorId = null
    state.typeDoctorId = null
    state.firstName = null
    state.lastName = null
    state.imageUrl = null
    state.email = null
    state.role = null
    state.tel = null
    state.clinicId = null
    state.clinicName = null
    state.branchId = null
    state.branchName = null
    state.tokenExpire = null
    state.accessToken = null
  }
}

const getters = {
  branch: (state) => ({ ...state }),
  accessToken: (state) => state.accessToken,
  tokenExpire: (state) => state.tokenExpire
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
